const CollapseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M3.52734 3.52539H11.7167V11.7134L14.4773 8.94125L15.2244 9.68835L11.1903 13.7225L7.15403 9.68619L7.90114 8.94703L10.6675 11.7134V4.57464H3.52734V3.52539Z"
        fill="#6F6464"
      />
    </svg>
  );
};

export default CollapseIcon;
